import { Component } from 'react';
import PropTypes from 'prop-types';

export class WarningCell extends Component {
  render() {
    const { children } = this.props;
    return (children);
  }
}

WarningCell.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  warning: PropTypes.bool,
};

WarningCell.defaultProps = {
  warning: false,
};
